import * as ws_base from '../ws/ws_base'


const DOMINIO = "subcategorias";


export async function buscarSubcategorias(id_categoria){

	return await ws_base.get(DOMINIO, "obter", {"id_categoria": id_categoria});
}


export async function removerSubcategoria(id_subcategoria){

	return await ws_base.get(DOMINIO, "remover", {"id_subcategoria": id_subcategoria});
}


export async function novaSubcategoria(id_categoria, nome, tags){

	return await ws_base.post(DOMINIO, "novo", {"id_categoria": id_categoria, "nome": nome, "tags": tags});
}